<template>
  <v-main class="promoter-config-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span>推广设置</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-container fluid class="content">
      <v-row dense>
        <v-col cols="12">
          <InputProfitRatioField label="免费推广员的佣金比例" v-model="form.initial_profit_ratio" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            type="number"
            label="抢客有效期"
            hint="用户在有效期内付费时，抢客的推广员有收益。默认0表示不支持抢客。"
            suffix="天"
            v-model="promoter_period_day"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            type="number"
            label="推广码锁定期"
            hint="（1）用户在锁定期内只能使用一次推广类兑换码 （2）新用户在锁定期内使用推广码关联推广员为拉新，否则关联为抢客。默认0表示无锁定期。"
            suffix="天"
            v-model="redeem_code_period_day"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            label="提现说明"
            hint="显示在推广员界面上"
            placeholder="一句话说明"
            v-model="form.intro_title"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            label="提现详细介绍"
            hint="显示在推广员提现详情上，支持Markdown/HTML格式"
            placeholder="支持Markdown/HTML格式"
            v-model="form.intro_md"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <div class="preview-label">提现详细展示</div>
          <div class="payout-desc markdown-body" v-if="introHtml" v-html="introHtml"></div>
        </v-col>
      </v-row>
      <v-btn width="100%" color="primary" class="mt-8" @click="onSave">保存</v-btn>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import InputProfitRatioField from '@/components/InputProfitRatioField.vue'
import { homeStore } from '@/store/home'
import { projectStore } from '@/store/project'
import _ from 'lodash'

const ONE_DAY = 24 * 60 * 60

function createComputedDayField(name) {
  return {
    get() {
      if (_.isNil(this.form[name])) {
        return null
      }
      return Math.round(this.form[name] / ONE_DAY)
    },
    set(value) {
      if (_.isNil(value) || value === 0 || value === '') {
        this.form[name] = null
      } else {
        this.form[name] = value * ONE_DAY
      }
    },
  }
}

export default {
  name: 'PromoterConfigPage',
  components: { AppbarBackIcon, InputProfitRatioField },
  data() {
    return {
      form: {
        initial_profit_ratio: null,
        promoter_period: null,
        redeem_code_period: null,
        intro_title: null,
        intro_md: null,
      },
    }
  },
  computed: {
    config() {
      return projectStore.current?.promoter_config
    },
    introHtml() {
      return this.config?.intro_html
    },
    promoter_period_day: createComputedDayField('promoter_period'),
    redeem_code_period_day: createComputedDayField('redeem_code_period'),
  },
  async mounted() {
    await homeStore.doLoad()
    if (this.config) {
      this.form.initial_profit_ratio = this.config.initial_profit_ratio
      this.form.promoter_period = this.config.promoter_period
      this.form.redeem_code_period = this.config.redeem_code_period
      this.form.intro_title = this.config.intro_title
      this.form.intro_md = this.config.intro_md
    }
  },
  methods: {
    async onSave() {
      await projectStore.doUpdate({
        id: projectStore.currentId,
        promoter_config: this.form,
      })
      this.$toasted.success('保存成功')
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.preview-label {
  font-size: 12px;
  color: @antTextSemi;
  padding: 4px 0;
}

.payout-desc {
  padding: 16px;
  background: @antBackWhite;
  border-radius: 8px;
  margin-bottom: 16px;
  border: solid 1px @antTextLight;
}
</style>
